export const ACCEPTED_PERSON_PROFILE_DOCUMENT_FILES = ".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.txt";

export const MEMBERSHIP_SERVICES_PRIVATE_CATEGORIES = new Set([
  "affiliate_application",
  "associate_application",
  "beneficiary",
  "member_application"
]);

export type PersonProfileDocumentCategory = {
  value: string;
  label: string;
  uploadable: boolean;
};

export type PersonProfileDocumentFormState = {
  name: string;
  description: string;
  category: string;
  privacyRestricted: boolean;
  file: File | null;
};

export const emptyPersonProfileDocumentForm: PersonProfileDocumentFormState = {
  name: "",
  description: "",
  category: "",
  privacyRestricted: false,
  file: null
};

export function filenameStem(filename: string) {
  return filename.replace(/\.[^/.]+$/, "");
}

export function isMembershipServicesPrivateCategory(category: string) {
  return MEMBERSHIP_SERVICES_PRIVATE_CATEGORIES.has(category);
}

export function formCategoryOptions(
  categories: PersonProfileDocumentCategory[],
  mode: "create" | "edit",
  currentCategory?: string
) {
  return categories.filter((option) => option.uploadable || (mode === "edit" && option.value === currentCategory));
}

export function getInitialPersonProfileDocumentForm(document?: {
  name: string;
  description?: string | null;
  category: string;
  privacyRestricted: boolean;
}): PersonProfileDocumentFormState {
  if (!document) return emptyPersonProfileDocumentForm;

  return {
    name: document.name,
    description: document.description ?? "",
    category: document.category,
    privacyRestricted: document.privacyRestricted,
    file: null
  };
}

export function isPersonProfileDocumentFormComplete(form: PersonProfileDocumentFormState, fileError = "") {
  return !!form.name.trim() && !!form.category && !!form.file && !fileError;
}

export function resolvedPrivacyRestricted(form: PersonProfileDocumentFormState) {
  return isMembershipServicesPrivateCategory(form.category) || form.privacyRestricted;
}

export function isProfileDocumentHiddenFromViewer(document: { privacyRestricted?: boolean; url?: string | null }) {
  return Boolean(document.privacyRestricted) && !document.url;
}
